export default __webpack_public_path__ + "static/gallery-4bd2dc018cf5279d83c021891f53e92b.pdf";